module.exports = __webpack_public_path__ + "media/images/home-screen-backgroud2-9c3e19e85a5a4df10c421134ad1442f7.png";